import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Stack,
  TextField,
  Typography,
} from '@mui/material';
import {
  BluAsyncDialog,
  BluCloudThemeProvider,
  BluDatePicker,
} from '@bludata/components';
import { useState } from 'react';
import dayjs, { Dayjs } from 'dayjs';
import { dateFormat } from '@focus.cloud/src/utility_objects/const/costants';

interface DialogAsyncProps {
  onClose: (result: { lotto?: string; dataScadenza?: string }) => void;
}

export default function DialogAsyncSelezioneLotto({
  onClose,
}: DialogAsyncProps) {
  const [lotto, setLotto] = useState<string>('');
  const [dataScadenza, setDataScadenza] = useState<string>('');

  const themeMode =
    window.document.querySelector('html')?.getAttribute('dark-mode') === 'true'
      ? 'dark'
      : 'light';

  const handleSend = () => {
    if (lotto === '') {
      BluAsyncDialog({
        title: 'Attenzione',
        message: 'Inserire un lotto valido',
        type: 'warning',
        hideDeclineButton: true,
        confirmButton: 'Ok',
      });
      return;
    }

    onClose({ lotto, dataScadenza });
  };

  return (
    <BluCloudThemeProvider themeMode={themeMode}>
      <Dialog open={true} fullWidth maxWidth="xs" fullScreen={false}>
        <DialogTitle>Selezione lotto</DialogTitle>
        <DialogContent
          sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}
        >
          <Typography>
            Leggi il codice a barre del lotto o inseriscilo manualmente
          </Typography>
          <Stack direction="row" gap={1} flex={1}>
            <TextField
              label="Lotto"
              value={lotto}
              sx={{ flex: 1 }}
              slotProps={{
                htmlInput: { maxLength: 25 },
              }}
              autoFocus
              onChange={(e) => setLotto(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') {
                  handleSend();
                }
              }}
            />
            <BluDatePicker
              format="DD/MM/YYYY"
              value={dataScadenza ? dayjs(dataScadenza) : null}
              label="Data scadenza"
              onChange={(newDate: Dayjs | null) => {
                setDataScadenza(newDate?.format(dateFormat) || null);
              }}
              slotProps={{
                textField: {
                  sx: { width: 150 },
                },
              }}
            />
          </Stack>
        </DialogContent>
        <DialogActions>
          <Button
            variant="outlined"
            sx={{ justifyContent: 'center' }}
            onClick={() => onClose({})}
          >
            Annulla
          </Button>
          <Button
            variant="outlined"
            sx={{ justifyContent: 'center' }}
            onClick={handleSend}
          >
            Invia
          </Button>
        </DialogActions>
      </Dialog>
    </BluCloudThemeProvider>
  );
}
